import { useFormPersistenceContext } from '@/contexts/form-persistence'
import { useCallback, useEffect, useRef } from 'react'
import { FieldValues, UseFormReturn } from 'react-hook-form'

export function useFormPersistence<T extends FieldValues>(
    form: UseFormReturn<T, any, any>,
    key: string,
    defaultValues: T
) {
    const { registerForm } = useFormPersistenceContext()
    const initializedRef = useRef(false)

    // chỉ gọi registerForm 1 lần duy nhất khi mount
    useEffect(() => {
        if (!initializedRef.current) {
            registerForm(form, key, defaultValues)
            initializedRef.current = true
        }
    }, [])

    useEffect(() => {
        const subscription = form.watch((value) => {
            try {
                localStorage.setItem(key, JSON.stringify(value))
            } catch (e) {
                console.warn('Không thể lưu localStorage', e)
            }
        })
        return () => subscription.unsubscribe()
    }, [form, key])

    const clear = useCallback(() => {
        try {
            localStorage.removeItem(key)
            form.reset(defaultValues)
        } catch (e) {
            console.warn('Không thể xóa localStorage', e)
        }
    }, [key, form, defaultValues])

    const clearOnly = useCallback(() => {
        try {
            localStorage.removeItem(key)
        } catch (e) {
            console.warn('Không thể xóa localStorage', e)
        }
    }, [key])

    return { clear, clearOnly }
}
